import React from 'react';
import Card from '../../components/ui/Card/Card';
import Skeleton from '../../components/ui/Skeleton/Skeleton';
import styles from './UserDetail.module.css';

const FieldSk = () => (
  <div className={styles.detailField}>
    <Skeleton width={60} height={12} />
    <Skeleton width="100%" height={46} className={styles.skRounded} />
  </div>
);

const UserDetailSkeleton: React.FC = () => (
  <div className={styles.page}>
    <div className={styles.topGrid}>
      {/* Users Details */}
      <Card>
        <Skeleton width={180} height={26} className={styles.skTitle} />
        <div className={styles.detailGrid}>
          <FieldSk />
          <FieldSk />
          <FieldSk />
          <FieldSk />
        </div>
        <div className={styles.detailActions}>
          <Skeleton width="100%" height={40} className={styles.skRounded} />
          <Skeleton width="100%" height={40} className={styles.skRounded} />
        </div>
      </Card>

      {/* Permissions */}
      <Card>
        <Skeleton width={160} height={26} className={styles.skTitle} />
        <div className={styles.skPermList}>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className={styles.skPermRow}>
              <Skeleton width={17} height={17} className={styles.skBox} />
              <Skeleton width={`${45 + ((i * 13) % 40)}%`} height={14} />
            </div>
          ))}
        </div>
      </Card>
    </div>

    <div className={styles.bottomGrid}>
      {[0, 1].map((col) => (
        <Card key={col}>
          <Skeleton width={110} height={18} className={styles.skTitle} />
          <Skeleton width="100%" height={44} className={styles.skRounded} />
          <div className={styles.skRows}>
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className={styles.skListRow}>
                <Skeleton width="55%" height={14} />
                <Skeleton width={84} height={24} className={styles.skRounded} />
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export default UserDetailSkeleton;
